import type { Spaces } from '@susu/headless-commerce/gql/generated/graphql'
import classNames from 'classnames'
import { useMemo } from 'react'

import style from './VerticalSpacing.module.scss'

type VerticalSpacingVariables = {
  [key: string]: string
}

export type VerticalSpacingProps = {
  data:
    | (Pick<Spaces, 'mobileHeight' | 'tabletHeight' | 'desktopHeight'> & {})
    | null
    | undefined
}

export const DEFAULT_VERTICAL_SPACING = '50px'

export default function VerticalSpacing({
  data,
}: Readonly<VerticalSpacingProps>) {
  const verticalSpacingClass = classNames(style['vertical-spacing'])
  const { mobileHeight, tabletHeight, desktopHeight } = data ?? {}
  const verticalSpacingVariables: VerticalSpacingVariables = useMemo(() => {
    return {
      '--mobile-height': mobileHeight ?? DEFAULT_VERTICAL_SPACING,
      '--tablet-height': tabletHeight ?? DEFAULT_VERTICAL_SPACING,
      '--desktop-height': desktopHeight ?? DEFAULT_VERTICAL_SPACING,
    }
  }, [mobileHeight, tabletHeight, desktopHeight])

  return (
    <div className={verticalSpacingClass} style={verticalSpacingVariables} />
  )
}
